import '@mzara/control-list-designer/dist/main.css'
import '@mzara/control-list-designer/dist/index.css'

export * from "./PageStaticRoutes"
export * from './PagePublicStaticRoutes'
export * from './containers/PublicStaticPageContainer'
